import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

export function WidgetDragHandle() {
  return (
    <span
      className="react-grid-dragHandleExample"
      style={{
        cursor: 'move',
        marginRight: '15px',
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      <DragIndicatorIcon fontSize="small" />
    </span>
  );
}
